/// <amd-module name="Core/Medius.Core.Web/Scripts/components/emailStatusTab/helpers/emailStatusTabVisibility"/>
import { isEmailStatusTabEnabled } from 'Core/Medius.Core.Web/Scripts/Medius/core/featureToggle';
import { ITaskDocument } from 'Core/Medius.Core.Web/Scripts/customTabs/interfaces';

const INVOICE_TYPE_MAPPING = {
    nonPO: 'Medius.ExpenseInvoice.Entities.ExpenseInvoice, Medius.ExpenseInvoice.Common',
    PO: 'Medius.OrderbasedInvoice.Entities.OrderbasedInvoice, Medius.OrderbasedInvoice.Common',
    recurringInvoice: 'Medius.ContractbasedInvoice.Entities.ContractbasedInvoice, Medius.ContractbasedInvoice.Common',
    prepaymentInvoice: 'Medius.Apa.Persistence.PrepaymentInvoice.PrepaymentSupplierInvoice',
    documentImport: 'Medius.Core.Entities.Integration.EDIDocumentImport, Medius.Core.Common',
    incomingInvoice:
        'Medius.PurchaseToPay.Platform.CCF.Services.DTOs.CaptureDocumentDto, Medius.PurchaseToPay.Platform',
    draft: 'Medius.Core.Entities.DocumentRegistration.Draft, Medius.Core.Common',
    creditMemo: 'Medius.PurchaseToPay.Entities.ShortPayment.CreditMemo, Medius.PurchaseToPay.Common',
} as const;

const ALLOWED_TYPES = new Set<string>(Object.entries(INVOICE_TYPE_MAPPING).map(([, value]) => value));

const WRAPPED_INVOICE_TYPE_MAPPING = {
    nonPO: 'Medius.ExpenseInvoice.Entities.ExpenseInvoice',
    PO: 'Medius.OrderbasedInvoice.Entities.OrderbasedInvoice',
    recurringInvoice: 'Medius.ContractbasedInvoice.Entities.ContractbasedInvoice',
    prepaymentInvoice: 'Medius.Apa.Persistence.PrepaymentInvoice.PrepaymentSupplierInvoice',
    documentImport: 'Medius.Core.Entities.Integration.EDIDocumentImport',
    incomingInvoice: 'Medius.PurchaseToPay.Platform.CCF.Services.DTOs.CaptureDocumentDto',
} as const;

const WRAPPED_INVOICE_TYPES = new Set<string>(Object.values(WRAPPED_INVOICE_TYPE_MAPPING));

export function shouldRenderEmailStatusTab(document: ITaskDocument): boolean {
    if (!isEmailStatusTabEnabled() || !document?.$type) {
        return false;
    }

    const type = document.$type;

    // Special handling for draft documents: ensure the wrapped document type is an allowed invoice type
    if (type === INVOICE_TYPE_MAPPING.draft) {
        const wrappedTypeRaw = document?.WrappedDocumentType;
        if (!wrappedTypeRaw) {
            return false;
        }
        return WRAPPED_INVOICE_TYPES.has(wrappedTypeRaw);
    }

    return ALLOWED_TYPES.has(type);
}
